import React, { Component } from "react";
import { Route, BrowserRouter, Switch } from "react-router-dom";
import Navigation from "./components/Navigation";
import Home from "./components/Home";
import News from "./components/News";
import GalleryView from "./components/GalleryView";
import Contact from "./components/Contact";
import Documents from "./components/Documents";
import Fixtures from "./components/Fixtures";
import M from "materialize-css";
import Footer from "./components/Footer";
import Committee from "./components/Committee";

import "materialize-css/dist/css/materialize.min.css";

class App extends Component {
  componentDidMount() {
    M.AutoInit();
  }

  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <Navigation />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route
              path="/fixtures"
              component={(props) => <Fixtures {...props} isSummer={true} />}
            />
            <Route exact path="/documents" component={Documents} />
            <Route exact path="/committee" component={Committee} />
            <Route exact path="/news" component={News} />
            <Route exact path="/gallery" component={GalleryView} />
            <Route exact path="/contact" component={Contact} />
            {/* <Route
              exact
              path="/summer"
              component={(props) => <Fixtures {...props} isSummer={true} />}
            /> */}
          </Switch>
          <Footer />
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
